import React from 'react';

export default function DragHandleIcon({ size = 16, color = '#9CA3AF', ...props }) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" aria-hidden="true" {...props}>
      <circle cx="5" cy="4" r="1.2" fill={color} />
      <circle cx="11" cy="4" r="1.2" fill={color} />
      <circle cx="5" cy="8" r="1.2" fill={color} />
      <circle cx="11" cy="8" r="1.2" fill={color} />
      <circle cx="5" cy="12" r="1.2" fill={color} />
      <circle cx="11" cy="12" r="1.2" fill={color} />
    </svg>
  );
}
